import React from 'react';
import { CancelationContentText } from './CancelationContentText';
import { CancellationFormContainer } from './CancellationFormContainer';
import { UtmParamsType } from '../interface';
import { JobDetailsFragment } from '../../graphql';
import { FragmentType } from '@mp/graphql/generated';

export const CancelationContent = ({
  job,
  closeDialog,
  utmParams,
}: {
  job?: FragmentType<typeof JobDetailsFragment> | null;
  closeDialog: () => void;
  utmParams?: UtmParamsType;
}) => {
  return (
    <>
      <CancelationContentText job={job} />
      <CancellationFormContainer closeDialog={closeDialog} utmParams={utmParams} job={job} />
    </>
  );
};
